import { FormArray, FormGroup } from '@angular/forms';
import { TransformToFormControl } from './common';

export type OrganizationMember = {
  position: Nullable<string>;
  name: Nullable<string>;
  contacts: OrganizationMemberContact[];
};

export type OrganizationMemberForm = TransformToFormControl<
  Omit<OrganizationMember, 'contacts'>
> & {
  contacts: FormArray<FormGroup<OrganizationMemberContactForm>>;
};

export enum ContactType {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  TELEGRAM_NICKNAME = 'TELEGRAM_NICKNAME',
}

export type OrganizationMemberContactForm =
  TransformToFormControl<OrganizationMemberContact>;

export type OrganizationMemberContact = {
  type: Nullable<ContactType>;
  value: Nullable<string>;
};
